import { Injectable } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { IAuthentication } from "../../interfaces/services/auth-service.interface";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class AuthService implements IAuthentication{
  constructor(private oauthService: OAuthService, private router: Router) {}
  login(): Promise<boolean> {
    this.oauthService.initCodeFlow();
    return Promise.resolve(true);
  }

  logout(): Promise<boolean> {
    const clientId = this.oauthService.clientId;

    const tokenKeys = [
      'access_token',
      'id_token',
      'id_token_claims_obj',
      'id_token_expires_at',
      'access_token_stored_at',
      'access_token_expires_at',
      'expires_at',
      'refresh_token',
      'granted_scopes',
      'nonce',
      'PKCE_code_verifier',
      'PKCE_verifier',
      'trimble_serial_pkce_verifier',
      'session_state',
    ];

    tokenKeys.forEach(key => {
      const fullKey = clientId ? `${clientId}_${key}` : key;
      sessionStorage.removeItem(fullKey);
      sessionStorage.removeItem(key);
    });

    this.oauthService.initCodeFlow('', { prompt: 'login' });
    return Promise.resolve(true);
  }

  isAuthenticated(): boolean {
    return this.oauthService.hasValidIdToken() && this.oauthService.hasValidAccessToken();
  }

  get accessToken(): string {
    return this.oauthService.getAccessToken();
  }

  get idToken(): string {
    return this.oauthService.getIdToken();
  }

  getProfile(): any {
    const profile = this.oauthService.getIdentityClaims();
    return profile;
  }
}